/**
 * Any-account person profile self-create (People CTAs + Settings).
 * Server and Vite must use the literal string "true".
 */

export function isPeopleProfileSelfCreateEnabled(
  ...args: [] | [string | undefined]
): boolean {
  const value =
    args.length === 0
      ? typeof process !== 'undefined'
        ? process.env.PEOPLE_PROFILE_SELF_CREATE_ENABLED
        : undefined
      : args[0];
  return value === 'true';
}

/** Client/Vite mirror of PEOPLE_PROFILE_SELF_CREATE_ENABLED. */
export function isPeopleProfileSelfCreateUiEnabled(
  value: string | undefined,
): boolean {
  return value === 'true';
}

/**
 * Unclaimed stubs, claim, unlist, admin import.
 * Server and Vite must use the literal string "true".
 */
export function isPeopleProfileClaimEnabled(
  ...args: [] | [string | undefined]
): boolean {
  const value =
    args.length === 0
      ? typeof process !== 'undefined'
        ? process.env.PEOPLE_PROFILE_CLAIM_ENABLED
        : undefined
      : args[0];
  return value === 'true';
}

export function isPeopleProfileClaimUiEnabled(
  value: string | undefined,
): boolean {
  return value === 'true';
}
